import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ManufacturedBy } from 'src/app/models/manufacturer';
import { ValidationResult } from 'src/app/models/validation-result';
import { MedicationService } from 'src/app/services/medication.service';
import { Settings } from 'src/app/services/settings';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { DwUtils } from '../utils/dw-utils';

@Component({
	selector: 'app-quickaddmanuby',
	templateUrl: './quickaddmanuby.component.html',
	styleUrls: ['./quickaddmanuby.component.css']
})
export class QuickaddmanubyComponent {
	public strErr: string | null = '';
	public id: any | null = '';
	public valDescription: any | null = '';

	public valStatus: any;
	@Output() submitClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();
	selectedRecord: ManufacturedBy;
	constructor(private medicationService: MedicationService, private txService: TransactionHistoryService,
		public dialog: MatDialog) {
	}

	ngOnInit() {

	}
	public onShowHandler() {
		this.clear();
		DwUtils.setFocus('desc');
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}

		return true;
	}
	clear() {
		this.valDescription = '';
	}

	public setRecord(): void {
		this.selectedRecord = new ManufacturedBy();
		this.selectedRecord.id = 0;
		this.selectedRecord.description = this.valDescription;
		this.selectedRecord.activeStatus = 'Active';
	}
	public submitRecord() {

		this.setRecord();
		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		this.medicationService.createManufactureBy(this.selectedRecord).subscribe(
			(data) => {
				if (data === undefined || data === null) {
					return;
				}
				this.selectedRecord.id = data.id;
				this.clear();
				/*** add a transaction history record ***/
				this.txService.createTransactionHistory('manu-for', this.selectedRecord.id);
				this.medicationService.getAllManufactureBy().subscribe(
					(data2) => {
						Settings.getInstance().manufactureByList = data2;
						this.submitClicked.emit(data);
					},
					(error2) => {

					}
				);
			},
			(error) => {
				this.strErr = 'Error: The server could not add/submit this record';
				return;
			}
		);

	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.cancelClicked.emit();
	}
}



